import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Container,Row, Col,Form,Button,Alert,CardImg} from 'reactstrap'
import {getFilterReviewList,AddReview} from '../actions/reviewActions'
import {getListParticipantParuser} from '../actions/eventsActions';
import Recaptcha from 'react-recaptcha';

class SatisfactionClient extends Component {
  constructor(props) {
        super(props);
        this.state = {
            idAvis:'',
            title : null,
            nom : null,
            email : null,
            message : null,
            active : null,
            recaptchaVerified: false,
            userId: localStorage.getItem('ps_user_id')
        };
        this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
    }
  

    recaptchaLoaded() {
      console.log('Recaptcha loaded successfully');
  }

  verifyCallback(response) {
      if (response) {
          this.setState({ recaptchaVerified: true });
      }
  }

    calculateMoyenne = () => {
      const { fetching, data } = this.props.review;
    
      try {
        if (!fetching) {
          if (data != null) {
            const totalNotes = data.reduce((total, item) => {
              if (item.status === "1") {
                const noteAsNumber = Number(item.note);
                if (!isNaN(noteAsNumber)) {
                  return total + noteAsNumber / 5;
                }
              }
              return total;
            }, 0);
    
            return totalNotes.toFixed(1);
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      } catch (error) {
        console.error("Erreur dans calculateMoyenne :", error);
        return 0;
      }
    };
    
    totalReponse = () => {
     
        const  {fetching,data}   = this.props.review
        try {
          if (!fetching) {
             if (data != null) {
                const totalNotes = data.reduce(
                  (total, item) => {
                    if (item.status === "1") {
                    return total += 1;
                  }
                  return total
                  }
                  ,0);

                  if (totalNotes > 1) {
                     return `${totalNotes} réponses`;
                  }else{
                    return `${totalNotes} réponse`;
                  }
               }else{
                  return `0 réponse`;
                }
          }else{
            return `0 réponse`;
          }
        } catch (error) {
          
          console.error("Erreur dans totalReponse :", error);
          return 0; // Retournez une valeur par défaut en cas d'erreur.
        }
      };


  componentDidMount() {
    let {getFilterReviewList} = this.props
    let {getListParticipantParuser} = this.props
    getListParticipantParuser(this.state.userId)
    getFilterReviewList();
  }

  componentDidUpdate() { }

  handleSelectChange = (e) => {
    this.setState({ idAvis: e.target.value });
  };

  change = e =>{
        this.setState({
            [e.target.id] : e.target.value
        }); 
  };
  submit = e =>{
        e.preventDefault();
         let {AddReview} = this.props
        const formData = {
            note:this.state.idAvis,
            title : this.state.title,
            nom : this.state.nom,
            email : this.state.email,
            message : this.state.message,
            active : this.state.active,
        };
        if (this.state.recaptchaVerified) {
          AddReview(formData)
        } else {
          this.setState({ recaptchaVerified: false });
        }
       
    }

  formatDate(dateString) {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };

    return date.toLocaleDateString('fr-FR', options);
  }


  render() {
    let {fetching, data, avis} = this.props.review
    let {participation} = this.props.events

    console.log(participation.alerte)
   
    return (
      <div>
        <Container className="mb-4 section-start">
            <Row>
                <Col xs="12" md="6" lg="6" className="column-start-left">
                    <Row>
                      <Col xs="12" md="7" lg="7" className="aside-start-left">
                          <div className="start-vide mb-2">
                            <CardImg src="/images/logo/star-empty.svg" alt="zone"/>
                            <CardImg src="/images/logo/star-empty.svg" alt="zone"/>
                            <CardImg src="/images/logo/star-empty.svg" alt="zone"/>
                            <CardImg src="/images/logo/star-empty.svg" alt="zone"/>
                             <br/><p>Note moyenne:<span>{this.calculateMoyenne()}/5</span></p>
                           </div>

                         
                      </Col>
                      <Col xs="12" md="5" lg="5">
                        <span className="start-service">{this.totalReponse()}</span>
                      </Col>
                    </Row>
                </Col>
                <Col xs="12" md="6" lg="6" className="column-start-right">
                  <Row>
                    <Col xs="12" md="3" lg="3">
                    <div className="grid">
                      <div className="my-4 mx-4" role="progressbar"  aria-valuemin="0" aria-valuemax="100" ></div>
                      </div>
                    </Col>
                    <Col xs="12" md="9" lg="9">
                      
                      <div className="cabinet-client mt-3">
                        <h6>100 % de nos clients recommandent notre cabinet</h6>
                      </div>
                    </Col>
                  </Row>
                </Col>
            </Row>
            <Row className="start-block">
                <Col xs="12" md="6" lg="6">
                  <h3>Professionnalisme</h3>
                  <p>Compétences de l’équipe d’accompagnement</p>
                </Col>
                <Col xs="12" md="6" lg="6" className="text-center">
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                </Col>
            </Row>
            <Row className="start-block">
                <Col xs="12" md="6" lg="6">
                  <h3>Disponibilité de l’équipe</h3>
                  <p>Démarrage du bilan, respect des rendez-vous</p>
                </Col>
                <Col xs="12" md="6" lg="6" className="text-center">
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                </Col>
            </Row>
            <Row className="start-block">
                <Col xs="12" md="6" lg="6">
                  <h3>Ouverture</h3>
                  <p>Respect, non-jugement</p>
                </Col>
                <Col xs="12" md="6" lg="6" className="text-center">
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                </Col>
            </Row>
            <Row className="start-block">
                <Col xs="12" md="6" lg="6">
                  <h3>Implication</h3>
                  <p>Capacité d’écoute, disponibilité</p>
                </Col>
                <Col xs="12" md="6" lg="6" className="text-center">
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                    <CardImg src="/images/logo/star-full.svg" alt="zone"/>
                </Col>
            </Row>
            {fetching ?
              <div className="my-4 py-4 px-4 reponse">Aucun avis n’a été donné pour le moment. Soyez le premier à en écrire un.</div>
              :
              <div>
                {data && data.map((item, key) => (
                  (item.status === '1') ? (
                    <div className="list-review">
                      <div className="d-flex start-vide">
                        <h5>{item.title}</h5>
                      </div>
                      <p className="review-date"><span className="note">note:{item.note}/5</span>&nbsp;&nbsp; {this.formatDate(item.date_add)}</p>
                      <hr/>
                      <p>{item.message}</p>
                    </div>
                    ):null
                ))}
              </div>
            }

            {participation && participation.alerte && participation.alerte.map((item, key) => (
                  (item.id_customer === this.state.userId) ? (
                    <fieldset className="bordure">
                    <legend><strong>« VOTRE AVIS NOUS INTÉRESSE »</strong></legend>
                    <Form onSubmit={this.submit} id="form-data" className="my-4 mx-4">
                     <Row className="form-avis my-3">
                         <Col md="2" lg="2">
                            <label className="my-2" for="inlineFormCustomSelectPref">Votre note globale :</label>
                         </Col>
                         <Col md="4" lg="4">
                            <select className="custom-select form-control" id="avis" onChange={this.handleSelectChange} required>
                              <option value="">Sectionnez votre note</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>   
                              <option value="4">4</option>
                              <option value="5">5</option>
                        </select>
                         </Col>
                     </Row>
                      <div className="form-group">
                          <label for="title">Titre de votre avis :</label>
                          <input type="text" className="form-control my-2" id="title" name="title" placeholder="Résumez votre avis ou mettez en évidence un détail intéressant" aria-describedby="Titre" onChange={this.change} required/>
                      </div>
                      <div className="form-group">
                          <label for="message">Votre avis :</label>
                          <textarea className="form-control message my-2" cols="5" rows="10" id ="message" name="message"  placeholder="Donnez votre avis" onChange={this.change} required></textarea>
                      </div>
                      <div className="form-group">
                          <label for="nom">Votre nom :</label>
                          <input type="text" className="form-control my-2" id="name" name="name" placeholder="Donnez votre nom" aria-describedby="Nom" onChange={this.change} required/>
                      </div>  
                      <div className="form-group">
                          <label for="email">Votre e-mail :</label>
                          <input type="email" className="form-control my-2" id="email" name="email" placeholder="Donnez votre e-mail" aria-describedby="E-mail" onChange={this.change} required/>
                      </div>        
                      <div className="form-group form-check pl-1 my-2">
                        <input type="checkbox" className="form-check-input" id="active"  onChange={this.change} required/>
                        <label className="form-check-label" for="exampleCheck1">Approuvé vos avis</label>
                      </div>
                      <Recaptcha
                          sitekey="6LcP5z4pAAAAAIDhHElH--sdYuF-7iJBaZTgnSME"
                          render="explicit"
                          onloadCallback={this.recaptchaLoaded}
                          verifyCallback={this.verifyCallback}
                          hl="fr"
                      />
                      <Button color="primary" className="mt-2">ENVOYER</Button>
                       {avis.check ?
                       <Alert color="success" className="my-4 mx-4 text-center px-4 py-4">
                              Vos informations  a bien été envoyé avec succès.
                        </Alert>
                        : null
                      }
                    </Form>
                </fieldset>
                    ):null
                ))}
           
        </Container>
      </div>
    )
  }
}

function mapStateToProps({reviewReducer,eventsReducer}) {
  return {
    review: reviewReducer,
    events: eventsReducer
  }
}
function mapDispatchToProps(dispatch) {
  return {
    getListParticipantParuser:bindActionCreators(getListParticipantParuser,dispatch),
    getFilterReviewList:bindActionCreators(getFilterReviewList, dispatch),
    AddReview: bindActionCreators(AddReview, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SatisfactionClient);


// WEBPACK FOOTER //
// ./src/components/SatisfactionClient.js